// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"e1a5e91f","453":"d00b9ba6","884":"3dc9a1ff"}[chunkId] + ".chunk.js";
};